import { WageFrequency } from "./enums";

// Pay set by agreement (organization wage sets and custom wages) uses the frequencies job
// offers allow: hourly pays the submitted hours, one-time pays once per shift.
export const PAY_WAGE_FREQUENCIES = [
  WageFrequency.Hourly,
  WageFrequency.OneTime,
] as const;

export type PayWageFrequency = (typeof PAY_WAGE_FREQUENCIES)[number];

// Dollars with up to two decimals, bounded by numeric(12, 2) columns.
export const WAGE_AMOUNT_PATTERN = /^\d{1,10}(\.\d{1,2})?$/;
